var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m5.516 3.459 3.54 3.54-3.54 3.542",
    opacity: 0.5
  })));
};
export default SvgChevronRight;